import React from 'react'
import { Button, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function GroupsEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Groups To Display.
        </h5>
        <div className='my-4'>
          When you have Groups they will appear here. Start by creating a Group below.
        </div>
        <Button as={Link} to='/vaccine/groups/create' variant='outline-primary' className="px-5">
          Create Group
        </Button>
      </Card.Body>
    </Card>
  )
}
